import { render, staticRenderFns } from "./NotificationListTable.vue?vue&type=template&id=2f535efc&scoped=true&lang=pug"
import script from "./NotificationListTable.vue?vue&type=script&lang=ts"
export * from "./NotificationListTable.vue?vue&type=script&lang=ts"
import style0 from "./NotificationListTable.vue?vue&type=style&index=0&id=2f535efc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f535efc",
  null
  
)

export default component.exports